<template>
  <div class="btn-group CheckboxOptions d-flex">
    <button v-if="!hideHandle" type="button" class="d-flex align-items-center handle btn btn-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="opened = true">
      <div class="checkbox-content-wrapper p-2 d-flex">
        <span class="d-flex align-items-center">
          <slot v-if="!temporaryName"></slot>
          <template v-else>
            {{ temporaryName }}
          </template>
        </span>

        <span v-if="selected.length" class="counter justify-content-center align-items-center">
          {{ selected.length }}
        </span>
      </div>

        <div class="arrow-wrapper px-2 d-flex align-items-center justify-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 20 20" fill="#999999">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </div>
    </button>
    <transition name="fade-trans">
      <ul v-if="opened" class="dropdown-menu disable-ske list-wrapper" :class="dropdownWrapperClass">
        <InfiniteScrolling ref="scroller"
          :show-end="loaded && !!items.length && showEnd"
          :searchMore="searchMore"
          :always-show-show-more-button="true"
        >
          <li>
            <slot name="above-input"></slot>
          
            <input ref="input" class="checkbox-options-input"
              v-model="search"
              placeholder="Zoek artikel..."
            />
          </li>
          <li><hr class="dropdown-divider"></li>
          <div v-if="loaded && items.length">
            <li v-for="item in items" :key="item[uid]"
              @click="toggleItem(item)"
            >
              <button class="dropdown-item" type="button">
                <FormCheckbox
                  :value="temporarySelection === item[uid] || selected.some(toCheck => item[uid] === toCheck[uid])"
                
                  :grayColor="true"
                  :rounded="radio"
                  :disable-toggle="true"
                >
                  {{ item[itemName] }}
                </FormCheckbox>
              </button>
            </li>
          </div>
          <div v-else-if="!items.length && loaded" class="d-flex justify-content-center align-items-center">
            <h4>
              List is empty
            </h4>
          </div>
          <div v-else>
            <li v-for="(str, i) in placeholderItems" :key="str + i">
              <button class="dropdown-item" type="button">
                <FormCheckbox :grayColor="true">
                  <span class="forced-ske"> {{ str }} </span>

                  <template #checkbox>
                    <span class="ml-3"></span>
                  </template>
                </FormCheckbox>
              </button>
            </li>
          </div>
        </InfiniteScrolling>

        <slot name="end-of-list" :close="close"></slot>
      </ul>
    </transition>
  </div>
</template>

<script>

import FormCheckbox from "../../../components/Inputs/FormCheckbox.vue"
import InfiniteScrolling from "../../InfiniteScrolling.vue"

import transitionFunctionConstructor from "src/mixins/transitionFunctionConstructor.js"

let timeout
const placeholderItems = [
  "Product",
  "Product group 1",
]

export default {
  mixins: [transitionFunctionConstructor()],
  components: {
    FormCheckbox,
    InfiniteScrolling,
  },
  props: {
    radio: Boolean,
    selectedName: String,
    value: String,
    dropdownWrapperClass: String,
    hideHandle: Boolean,
    defaultOpened: Boolean,

    selected: {
      type: Array,
      default: () => ([]),
    },
    endpoint: {
      type: String,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    itemName: {
      type: String,
      default: "name",
    },
    searchQuery: {
      default: "name",
    },
    type: {
      type: String,
      default: "name",
    },
    price: {
      type: String,
      required: false,
      default: "buy_price"
    },
    uid: {
      type: String,
      default: "uid",
    },
    params: Object,
    resetWhenClose: Boolean,
  },
  created() {
    if (this.radio && this.value) {
      this.temporarySelection = this.value
    }

    requestAnimationFrame(() => {
      if (this.defaultOpened !== undefined) {
        this.opened = this.defaultOpened || false
      }
    })
  },
  data() {
    return {
      search: "",
      items: [],
      opened: false,
      loaded: false,
      showEnd: false,
      searchingForMore: false,

      temporarySelection: null,
      temporaryName: null,

      placeholderItems: [
        ...placeholderItems,
        ...placeholderItems,
        ...placeholderItems,
        ...placeholderItems,
      ]
    }
  },
  methods: {
    open() {
      this.opened = true
    },
    close() {
      this.opened = false
    },
    toggleItem(item) {
      let selected = this.selected.slice()

      const obj = { name: item[this.itemName], [this.uid]: item[this.uid], type: this.type, price: item[this.price] }
      if (this.radio) {
        if (this.temporarySelection !== item[this.uid]) {
          selected = [obj]
          this.$emit("input", item[this.uid])
  
          this.temporarySelection = item[this.uid]
          this.temporaryName = item[this.itemName]
          this.$emit("update:selectedName", this.temporaryName)
          this.opened = false
        } else {
          selected = []
          this.$emit("input", null)
          this.$emit("update:selectedName", null)

          this.temporarySelection = null
          this.temporaryName = null
        }
      } else {
        const itemIndex = selected.findIndex(toCheck => toCheck[this.uid] === item[this.uid])
        
        if (itemIndex > -1) {
          selected.splice(itemIndex, 1)
        } else {
          selected.push(obj)
        }
      }

      this.$emit("update:selected", selected)
    },
    async searchMore(page = 1) {
      const items = (await this.axios.get(this.endpoint, {
        params: {
          page,
          page_size: this.pageSize,
          [this.searchQuery]: this.search,

          ...(this.params || {}),
        }
      })).data.results
      this.items = [...this.items, ...items]
      
      return items.length < this.pageSize
    },
    checkClickPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      } 

      if (!found) this.opened = false
    },
  },
  watch: {
    search() {
      if (timeout) {
        clearTimeout(timeout)
      }

      if (this.searchingForMore) return;
      timeout = setTimeout(async () => {
        this.searchingForMore = true
        
        this.showEnd = false
        this.items = []

        this.loaded = false
        await this.searchMore()
        this.searchingForMore = false
        this.loaded = true

        this.showEnd = this.items.length >= this.pageSize
        this.$refs.scroller.reset()
      }, 200)
    },
    async opened(val) {
      if (val) {
        window.addEventListener("click", this.checkClickPath)

        this.$nextTick(() => this.$refs.input.focus())

        this.loaded = false
        await this.searchMore()
        this.loaded = true
        
        this.showEnd = this.items.length >= this.pageSize
      } else {
        window.removeEventListener("click", this.checkClickPath)
        this.$emit("update:selected", [])
        this.items = []
        this.showEnd = false
      }
    },
  },
}

</script>

<style scoped>

.CheckboxOptions + .CheckboxOptions {
  margin-left: 16px;
}

.arrow-wrapper {
  border-left: 1px solid rgba(0, 0, 0, 0.125);
  height: 100%;
}

.checkbox-content-wrapper {
  flex-grow: 1;
}

.handle {
  display: flex !important;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: white !important;
  border-radius: 1px !important;
  font-size: 13px;
  padding: 0px !important;
  overflow: visible;
}

.dropdown-menu {
  display: block !important;
  opacity: 1;
  visibility: visible !important;
  padding-bottom: 8px;
  border-radius: 1px;
  width: 100%;
  min-width: 16em;
}

.dropdown-item {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 6px;
  padding-bottom: 6px;
}

input {
  padding: 12px;
  padding-bottom: 2px;
}

.list-wrapper {
  max-height: 370px;
  overflow: auto;
}

h4 {
  margin: 0;
  margin-top: 18px;
  margin-bottom: 18px;
  color: rgb(200,200,200) !important;
}

.counter {
  display: inline-flex;
  border-radius: 1px;
  background-color: rgb(240, 240, 240);
  padding: 0.5px 6px;
  margin: 0 3px;
}

</style>
